import * as React from 'react';
import {Card, Stack, Typography} from '@mui/material';
import ToolBoxButton from './buttons/ToolBoxButton';
import PoliceButton from './PoliceButton';
import UndoButton from './UndoButton';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {usePoliceMode} from '../policeMode/hook/usePoliceMode';

export default function ToolBox() {
  const {changeModeToDark, changeModeToWhite, mode} = useDarkMode();
  const {changeMode} = usePoliceMode();
  const handleChangeMode = () => {
    if (!mode.darkMode) {
      changeModeToDark();
    } else {
      changeModeToWhite();
    }
  };

    return (
        <Card class={'sideMenuCard'} style={{backgroundColor: mode.settings.cardBackgroundColor}}>
            <Stack direction="column" justifyContent="left" alignItems="center" spacing={2} padding={1}>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{marginTop:'7px'}}>
                    <img src={`/assets/icon/tool-box.png`} alt={'Boite à outil'}/>
                    <Typography variant={'subtitle2'} sx={{color:'#79A00B'}}>OUTILS</Typography>
                </Stack>
                <img src={`/assets/icon/card-divider.png`} alt={'Image de division'} style={{marginTop:'7px'}}/>
                <Stack direction="row" justifyContent="left" alignItems="flex-start" spacing={1}>
                    <PoliceButton text={'Police dyslexie'} icon={`/assets/icon/p.png`} iconSelected={`/assets/icon/P-white.png`} action={() => changeMode()}/>
                    <ToolBoxButton text={'Mode sombre'} icon={`/assets/icon/moon.png`} iconSelected={`/assets/icon/moon-white.png`} action={() => handleChangeMode()}/>
                </Stack>
            </Stack>
            <div id={"id_target_container"}></div>
        </Card>
    )
}
